import React, { FC, PropsWithChildren } from 'react';
import { cx } from 'linaria';
import { card, horizontalContent, horizontalLink, link, verticalContent } from './styles';

export const DATA_QA_SERVICE = 'service-link';

type Props = {
  className?: string;
  containerClassName?: string;
  href?: string;
  onClick?: () => void;
  vertical?: boolean;
  dataQA?: string;
} & PropsWithChildren;

export const OrientationContext = React.createContext(false);

export const ServiceCard: FC<Props> = ({
  children,
  href,
  onClick,
  className,
  vertical = false,
  dataQA,
  containerClassName,
}) => (
  <a
    data-qa={dataQA ? dataQA : DATA_QA_SERVICE}
    className={cx(link, !vertical ? horizontalLink : null, className)}
    target="_blank"
    rel="noopener noreferrer"
    href={href}
    onClick={onClick}
  >
    <OrientationContext.Provider value={vertical}>
      <div className={cx(card, vertical ? verticalContent : horizontalContent, containerClassName)}>
        {children}
      </div>
    </OrientationContext.Provider>
  </a>
);
